import SubjectForm from './SubjectForm';

export default function SubjectFormPage() {
  return <SubjectForm />;
}
